<script>
import Sidebar from '@/components/Admin/Sidebar';
import Toolbar from '@/components/Admin/Toolbar';

export default {
  name: 'AdminLayout',
  components: {
    Sidebar,
    Toolbar,
  },
  data() {
    return {
      routeStack: [],
    };
  },
  computed: {
    keepAliveInclude() {
      return [];
    },
    keepAliveExclude() {
      return [];
    },
  },
  methods: {
  },
};
</script>

<template lang="pug">
.application
  Toolbar.header
  .body
    .side-menu
      Sidebar
    .main-content
      slot
</template>

<style lang="stylus" scoped>
.application
  width 100%
  height 100vh
  padding-top 56px
  box-sizing border-box
  position relative
  .header
    position fixed
    top 0
    left 0
    width 100%
    z-index 1
  .body
    width 100%
    height 100%
    display flex
    overflow hidden
    .side-menu
      max-width 220px
      max-height calc(100vh - 56px)
    .main-content
      width 100%
      box-sizing border-box
      position relative
      overflow auto
      background #fff
</style>



// WEBPACK FOOTER //
// Admin.vue?ee3fde92